<div *ngIf="wrapped" class="form-group" [ngClass]="wrappedClass">
  <label for="{{name}}">{{label || (name | stringSpacer)}}:</label>
  <input #input type="text" [attr.disabled]="disabled ? 'disabled' : null" id="{{name}}" name="{{name}}" [ngClass]="class" maxlength="{{maxlength}}" placeholder="{{placeholder}}"
    class="form-control form-control-sm text-right" [(ngModel)]="display" (ngModelChange)="displayChanged($event)" (blur)="onBlur()" />
</div>

<input *ngIf="!wrapped" #input type="text" [attr.disabled]="disabled ? 'disabled' : null" id="{{name}}" name="{{name}}" [ngClass]="class" maxlength="{{maxlength}}"
  placeholder="{{placeholder}}" class="form-control form-control-sm text-right" [(ngModel)]="display" (ngModelChange)="displayChanged($event)" (blur)="onBlur()" />
